import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fe21314"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "error-modal--wrapper" }
const _hoisted_2 = { class: "error-modal__header" }
const _hoisted_3 = { class: "error-modal__header__text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "error-modal__header__text__subtitle" }, "Erreur", -1))
const _hoisted_5 = {
  id: "error-modal-title",
  class: "error-modal__header__text__title"
}
const _hoisted_6 = { class: "error-modal__content" }
const _hoisted_7 = { class: "error-modal__footer" }

import { withDefaults, onMounted, onBeforeUnmount } from 'vue';
import DangerIcon from '@/ui/components/bases/icons/DangerIcon.vue';

interface Props {
  title: string;
  primaryAction: string;
  secondaryAction?: string;
  critical?: boolean;
  messages: string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorModal',
  props: {
    title: null,
    primaryAction: null,
    secondaryAction: { default: undefined },
    critical: { type: Boolean, default: false },
    messages: null
  },
  emits: ['didRequestPrimaryAction', 'didRequestSecondaryAction'],
  setup(__props: any, { emit }) {





function didRequestPrimaryAction() {
  emit('didRequestPrimaryAction');
}

function didRequestSecondaryAction() {
  emit('didRequestSecondaryAction');
}

function onKeydown(event: KeyboardEvent) {
  if (event.key === 'Escape') {
    emit('didRequestPrimaryAction');
  }
}

onMounted(() => window.addEventListener('keydown', onKeydown));
onBeforeUnmount(() => window.removeEventListener('keydown', onKeydown));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["error-modal", __props.critical ? 'error-modal--critical' : null]),
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "error-modal-title"
    }, [
      _createElementVNode("header", _hoisted_2, [
        _createVNode(DangerIcon, { class: "error-modal__header__icon" }),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, _toDisplayString(__props.title), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.messages, (message) => {
          return (_openBlock(), _createElementBlock("p", { key: message }, _toDisplayString(message), 1))
        }), 128))
      ]),
      _createElementVNode("footer", _hoisted_7, [
        (__props.secondaryAction)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-small btn-light",
              onClick: didRequestSecondaryAction
            }, _toDisplayString(__props.secondaryAction), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-small",
          onClick: didRequestPrimaryAction
        }, _toDisplayString(__props.primaryAction), 1)
      ])
    ], 2)
  ]))
}
}

})